export const CLEAR_ANSWERS_CONFIRMATION_TEXT =
  "This action will clear all answers. Do you want to continue? (If needed, press cancel and save your current progress before proceeding)";
